"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.template_apply = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var template_apply = function template_apply(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'template_apply-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    d: 'M13.5 13.5V11.5C13.5 11.2239 13.7239 11 14 11H15C15.2761 11 15.5 11.2239 15.5 11.5V13.5H17.5C17.7761 13.5 18 13.7239 18 14V15C18 15.2761 17.7761 15.5 17.5 15.5H15.5V17.5C15.5 17.7761 15.2761 18 15 18H14C13.7239 18 13.5 17.7761 13.5 17.5V15.5H11.5C11.2239 15.5 11 15.2761 11 15V14C11 13.7239 11.2239 13.5 11.5 13.5H13.5Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M3.46967 16.0304C3.61032 16.171 3.80109 16.2501 4 16.2501H10.3386C10.131 16.0668 10 15.7987 10 15.5V14.7501H4.75L4.75 3.75017L11.25 3.75003L11.25 7C11.25 7.41421 11.5858 7.75 12 7.75H14.75V10H15.5C15.7987 10 16.0668 10.1309 16.25 10.3385V6C16.25 5.80109 16.171 5.61032 16.0303 5.46967L13.0303 2.46967C12.8897 2.32901 12.6989 2.25 12.5 2.25L3.99998 2.25019C3.58578 2.2502 3.25 2.58598 3.25 3.00019V15.5001C3.25 15.699 3.32902 15.8897 3.46967 16.0304ZM14.6893 6.25H12.75V4.31066L14.6893 6.25Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M10 6.75H6V5.25H10V6.75Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M6 9.75H10V8.25H6V9.75Z',
    fill: '#4B5563'
  }));
};

exports.template_apply = template_apply;